export default function ({ req, app }) {
  if (process.server && req) {
    const host = req.headers.host || ''
    const protocol = req.headers['x-forwarded-proto'] || 'https'
    const fullUrl = `${protocol}://${host}${req.url}`

    // 避免直接修改app参数，创建副本
    const appCopy = { ...app }
    appCopy.head = { ...appCopy.head }
    appCopy.head.link = [...(appCopy.head.link || [])]

    appCopy.head = app.head || {}
    appCopy.head.link = app.head.link || []

    // 去除 query/hash
    const cleanUrl = fullUrl.split('?')[0].split('#')[0]

    // 去除重复 canonical
    appCopy.head.link = app.head.link.filter((l) => l.rel !== 'canonical')

    appCopy.head.link.push({
      rel: 'canonical',
      href: cleanUrl,
    })
    appCopy.head.link = app.head.link.filter((l) => l.rel !== 'author')
    appCopy.head.link.push({
      rel: 'author',
      href: cleanUrl,
    })

    Object.assign(app, appCopy)
  }
}
